import {
	StyledTextProps,
	TextSize,
	TextWeight,
} from '@Components/Text/Text/types';
import styled from 'styled-components';

function getTextSize(size?: TextSize) {
	switch (size) {
		case 'extra-small':
			return '0.714rem';
		case 'small':
			return '0.857rem';
		case 'medium':
			return '1rem';
		case 'large':
			return '1.286rem';
		default:
			return '1rem';
	}
}

function getTextWeight(weight?: TextWeight) {
	switch (weight) {
		case 'extra-bold':
			return '800';
		case 'bold':
			return '700';
		case 'semi-bold':
			return '600';
		case 'medium':
			return '500';
		case 'regular':
			return '400';
		default:
			return '400';
	}
}

export const StyledText = styled.p<StyledTextProps>`
	font-size: ${({ size }) => getTextSize(size)};
	font-weight: ${({ weight }) => getTextWeight(weight)};
	color: ${({ color }) => color ?? '#000000'};
	${(props) =>
		props.maxLines &&
		`
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: ${props.maxLines};
		line-clamp: ${props.maxLines};
		-webkit-box-orient: vertical;

	`}
`;
